"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NBaseClose = void 0;
var Close_1 = require("./src/Close");
Object.defineProperty(exports, "NBaseClose", { enumerable: true, get: function () { return __importDefault(Close_1).default; } });
